exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bread[data-v-6fb60fcd]{color:#353C4599}.bread a[data-v-6fb60fcd]{text-decoration:underline;color:#353C4599}.bread a[data-v-6fb60fcd]:hover{cursor:pointer;color:#f6495c}.bread span[data-v-6fb60fcd]:not(.active){display:inline-block;margin-left:10px;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6fb60fcd","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true,"data":"@import /"/Users/pola/Documents/udemy/prototype_boxed_layout/src/assets/scss/variables.scss/";"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/WidgetBreadcrum.vue
// module id = 238
// module chunks = 0